import { getField } from 'vuex-map-fields';

export default {
  loadingInstantReplies: state => state.loadingInstantReplies,
  instantReplyList: state => state.instantReplyList,
  instantReply: state => state.instantReply,
  instantReplySaved: state => state.instantReplySaved,
  instantReplyDeleted: state => state.instantReplyDeleted,
  instantReplyMessageDeleted: state => state.instantReplyMessageDeleted,
  keywordAnalytics: state => state.keywordAnalytics,

  automationRules: state => state.automationRules,
  automationRulesLoaded: state => state.automationRulesLoaded,
  automationRuleSaved: state => state.automationRuleSaved,
  automationRuleDeleted: state => state.automationRuleDeleted,

  automationSettings: state => state.automationSettings,
  automationSettingsSaved: state => state.automationSettingsSaved,
  unsubscribeMessageSaved: state => state.unsubscribeMessageSaved,
  uploadedFile: state => state.uploadedFile,
  apiError: state => state.apiError,
  fileUploadError: state => state.fileUploadError,
  backgroundActions: state => state.backgroundActions,
  updatedAISchema: state => state.updatedAISchema,
  assistantDataSaved: state => state.assistantDataSaved,
  fileUploadCancelled: state => state.fileUploadCancelled,
  scrapingStatus: state => state.scrapingStatus,
  updatedCounter: state => state.updatedCounter,
  webScrapeCounter: state => state.webScrapeCounter,
  webScrapeDeleteCounter: state => state.webScrapeDeleteCounter,
  fileChangesTracker: state => state.fileChangesTracker,
  fileUploadCounter: state => state.fileUploadCounter,
  fileDeleteCounter: state => state.fileDeleteCounter,
  tempFileCounter: state => state.tempFileCounter,
  actionInProgress: state => state.actionInProgress,
  getField,
};
